import { yupResolver } from '@hookform/resolvers/yup'
import { ChevronRight, Email } from '@mui/icons-material'
import classNames from 'classnames'
import { EMAIL_REGEX } from 'constants/validation'
import { EmailSettingsForm } from 'feature/user/components/EmailSettingsForm/EmailSettingsForm'
import { useGetUserQuery } from 'feature/user/redux/user.api'
import { TEditEmailFormValues } from 'feature/user/types'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import * as yup from 'yup'

import style from './UserSettingsEmail.module.scss'

const schema = yup
  .object()
  .shape({
    email: yup
      .string()
      .email('Введите корректный email')
      .matches(EMAIL_REGEX, 'Введите корректный email')
      .test(
        'no-com-domain',
        `В связи с новым законодательством, вы не можете зарегистрировать аккаунт на 
        иностранный почтовый адрес (заканчивается на ".com"). Пожалуйста, воспользуйтесь другой почтой.`,
        value => {
          if (!value) return true

          return !value.toLowerCase().endsWith('.com')
        },
      )
      .required('Поле email обязательное'),
  })
  .required()

export function UserSettingsEmail() {
  const { data, isLoading } = useGetUserQuery()

  const formMethods = useForm<TEditEmailFormValues>({
    defaultValues: {
      email: '',
    },
    mode: 'all',
    //@ts-ignore
    resolver: yupResolver(schema),
  })

  const { setValue } = formMethods

  useEffect(() => {
    if (!data) return
    setValue('email', data.newEmail || data.email || '', {
      shouldValidate: true,
    })
  }, [data])

  if (isLoading) {
    return <LoaderInCentalPosition />
  }

  return (
    <section className={style.settingEmailPage}>
      <div className={style.header}>
        <Button
          // @ts-ignore
          to='/settings'
          variant='text'
          className={style.backButton}
          color='primary'
          startIcon={
            <ChevronRight
              color='primary'
              className={classNames('rotate180', style.chevronRight)}
            />
          }
        >
          Назад
        </Button>

        <div className={style.title}>
          <Email color='primary' />
          <span className='h1'>электронная почта</span>
        </div>
      </div>

      <FormProvider {...formMethods}>
        <EmailSettingsForm data={data} />
      </FormProvider>
    </section>
  )
}
